export const getFormatDistance = (shop) => {
    return shop.distance < 1000 ? Math.round(shop.distance / 50) * 50 + ' m' : Math.round((shop.distance / 100)) / 10 + ' km';
};
